import { AccessibilityModel } from "models/accessibility";
import { doGet } from "../request";

export const doGetAccessibility = async () => {
  const accessibility = await doGet<AccessibilityModel>("/accessibility");
  return accessibility;
};
